import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const ClinicSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titleHospital
      }
    >
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="clinic_name"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalName
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="clinic_ik_number"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalIkNumber
          }
          large
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="clinic_location_street"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalStreet
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="clinic_location_street_number"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalStreetNumber
          }
        />
        <TextInputWithLabel
          bold
          elementName="clinic_location_zipcode"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalZipCode
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="clinic_location_city"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalCity
          }
          large
        />
      </SectionRow>
    </Section>
  );
};
